/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Level_Tilt_ForwardInputs */

const en_us2_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilt the top of the phone forward`)
};

const pt_br2_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incline o topo do celular para a frente`)
};

const es_419_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclina la parte de arriba del teléfono hacia adelante`)
};

const pt_pt2_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclina o topo do telemóvel para a frente`)
};

const fr_fr2_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incline le haut du téléphone vers l'avant`)
};

const de_de2_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oberkante des Handys nach vorne kippen`)
};

const it_it2_body_assessment_level_tilt_forward = /** @type {(inputs: Body_Assessment_Level_Tilt_ForwardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclina la parte alta del telefono in avanti`)
};

/**
* | output |
* | --- |
* | "Tilt the top of the phone forward" |
*
* @param {Body_Assessment_Level_Tilt_ForwardInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_level_tilt_forward = /** @type {((inputs?: Body_Assessment_Level_Tilt_ForwardInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Level_Tilt_ForwardInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_level_tilt_forward(inputs)
	if (locale === "es-419") return es_419_body_assessment_level_tilt_forward(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_level_tilt_forward(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_level_tilt_forward(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_level_tilt_forward(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_level_tilt_forward(inputs)
	return en_us2_body_assessment_level_tilt_forward(inputs)
});
export { body_assessment_level_tilt_forward as "body-assessment.level_tilt_forward" }